import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

// Which editor to render is decided by CalculatedFilterEditDispatcher from the filter's own
// `type` (fetched from the detail endpoint), not from a `?type=` URL query param.
const CalculatedFiltersEditRoute = lazy(async () => {
  const { CalculatedFilterEditDispatcher } = await import("@segments/CalculatedFilterEditDispatcher");

  return { default: CalculatedFilterEditDispatcher };
});

export const calculatedFiltersEditNRO: NavigationRoutingObject = {
  Component: CalculatedFiltersEditRoute,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "audience",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("calculated-filters-edit-page-heading", "Edit Calculated Filter"),
  pageNameForTracking: () => "Edit Calculated Filter",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("calculated_filters");
  },
  showInSearchResults: false,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/calculated_filters/:appGroupId",
};
